var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.vertical ? 'AppTitle__vertical' : 'AppTitle',attrs:{"src":require('@/assets/mycontact.svg'),"alt":"mycontact"}})}
var staticRenderFns = []

export { render, staticRenderFns }